var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HtmlModal',{staticClass:"included-options-modal",attrs:{"title":"Included Options","is-opened":_vm.isOpened,"html":_vm.html},on:{"modal-closed":_vm.close}})}
var staticRenderFns = []

export { render, staticRenderFns }